<template>
  <BaseLabel :label="label" v-if="label" />

  <input
    v-bind="$attrs"
    :autofocus="autofocus"
    :class="[isInvalid ? invalidClass : activeClass]"
    :placeholder="placeholder ? placeholder : label"
    :value="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
    @focus="$emit('focus')"
  />

  <BaseInputError :message="message" v-if="isInvalid" />
</template>

<script>
import { inputMixin, notRequiredFormFieldMixin } from "@/mixins/form.js";

export default {
  mixins: [inputMixin, notRequiredFormFieldMixin],
};
</script>

<style lang="scss" scoped></style>
